const initialState = {
	open: false,
	quickAddedPaymentTerm: false
}

const actionTypes = {
    OPEN_REPORT_VIEWER_DIALOG: "OPEN_REPORT_VIEWER_DIALOG",
    CLOSE_REPORT_VIEWER_DIALOG: "CLOSE_REPORT_VIEWER_DIALOG",
	QUICK_ADDED_PAYMENT_TERM: "QUICK_ADDED_PAYMENT_TERM"
}

export function openReportViewerDialog(){
    return {
        type: actionTypes.OPEN_REPORT_VIEWER_DIALOG,
    }
}

export function closeReportViewerDialog(){
    return {
        type: actionTypes.CLOSE_REPORT_VIEWER_DIALOG,
    }
}


export function quickAddedPaymentTerm() {
	return {
		type: actionTypes.QUICK_ADDED_PAYMENT_TERM,
	}
}

export default function (state = initialState, action) {
	switch (action.type) {
		case actionTypes.OPEN_REPORT_VIEWER_DIALOG:{
			return { 
				...state,
				open: true,
			}
		}
		case actionTypes.CLOSE_REPORT_VIEWER_DIALOG:{
			return { 
				...state,
				open: false,
			}
		}
		case actionTypes.QUICK_ADDED_PAYMENT_TERM: {
			return {
				...state,
				quickAddedPaymentTerm: !state.quickAddedPaymentTerm
			}
		}
	  default:
		return state
	}
}